import React, { forwardRef } from 'react';

import { tw } from '../../utils/tailwind';

export const Box: FCWithClassName<JSX.IntrinsicElements['div']> = forwardRef(
  ({ children, className, style, ...rest }, forwardedRef) => {
    return (
      <div ref={forwardedRef} className={tw(className)} style={style} {...rest}>
        {children}
      </div>
    );
  }
);

Box.displayName = 'Box';
